export default __webpack_public_path__ + "static/media/fi.aed885cc.svg";